module.exports = __webpack_public_path__ + "img/ext-05.c2e50503.jpg";